<template>
  <v-layout>
    <v-flex xs6>
      <!-- A card with the list of values with switch to show raw values or mapped values -->
      <v-items-list />
    </v-flex>
    <v-flex xs6 class="ml-1">
      <!-- Another card to show the input to write the mapped value, similar mapped values and
      the values mapped to the active item selected from the other card-->
      <v-mapping-list />
    </v-flex>
  </v-layout>
</template>

<script>
import VMappingList from "./MappingList";
import VItemsList from "./ItemsList";

export default {
  components: {
    VMappingList,
    VItemsList
  }
};
</script>
